module.exports = __webpack_public_path__ + "static/4_QUEEN-00bc1bc91d791307c7835f35644e87e5.png";